import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@ps-design-system/components/Dialog";
import { Text } from "@ps-design-system/components/Text";

type DateRateDeleteDialogProps = {
  onDelete: () => void;
  onKeep: () => void;
  open: boolean;
};

/** Confirms deleting a date based rate. */
const DateRateDeleteDialog = ({
  onDelete,
  onKeep,
  open,
}: DateRateDeleteDialogProps) => {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onKeep();
    }
  };

  return (
    <Dialog onOpenChange={handleOpenChange} open={open}>
      <DialogContent size="sm" testId="date-rate-delete-dialog">
        <DialogHeader>
          <DialogTitle className="tw-m-0">
            <FormattedMessage
              id="hosting.date_rate_table.delete_dialog_heading"
              defaultMessage="Delete rate?"
            />
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Text element="p" className="tw-m-0">
            <FormattedMessage
              id="hosting.date_rate_table.delete_dialog_body"
              defaultMessage="These dates will go back to your day-of-week rate if you’ve set one. Otherwise, they’ll use your hourly base rate."
            />
          </Text>
        </DialogBody>
        <DialogFooter className="sm:tw-px-32 sm:tw-py-24">
          <div className="tw-flex tw-justify-between tw-items-center tw-w-full">
            <Button
              onClick={onKeep}
              testId="date-rate-delete-dialog-keep"
              variant="underline-m"
            >
              <FormattedMessage
                id="hosting.date_rate_table.delete_dialog_keep_button"
                defaultMessage="Keep rate"
              />
            </Button>
            <Button onClick={onDelete} testId="date-rate-delete-dialog-delete">
              <FormattedMessage
                id="hosting.date_rate_table.delete_dialog_delete_button"
                defaultMessage="Delete"
              />
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { DateRateDeleteDialog };
